<script>
export default {
	props: {
		basketItem: Object,
	},
	computed: {
		productPropRawValues() {
			return this.basketItem.combinationsPropertiesValues;
		},
	},
	methods: {
		getPropName(propCode) {
			return this.basketItem.combinationsPropertiesDescriptions[propCode]?.NAME;
		},
		getValuesDescriptions(propCode, productPropValueCode) {
			return this.basketItem.combinationsPropertiesDescriptions[propCode]?.VALUES[productPropValueCode];
		},
		getValue(propCode, propValueCode) {
			return this.getValuesDescriptions(propCode, propValueCode)?.NAME;
		},
	},
};
</script>

<template>
	<template v-if="basketItem.isOffer && productPropRawValues">
		<div 
			v-for="(productPropValueCode, propCode) in productPropRawValues" 
			:key="propCode+'-'+productPropValueCode"
			class="card-cart-item__prop"
		>
			<template v-if="productPropValueCode">
				<dt class="card-cart-item__prop-title">{{ getPropName(propCode) }}:</dt>
				<dd class="card-cart-item__prop-value">{{ getValue(propCode, productPropValueCode) }}</dd>
			</template>
		</div>
	</template>
</template>

<style scoped>

</style>
